module.exports = __webpack_public_path__ + "static/ZenithSlabDJR-Bold-4b0c47b1f34de0ab956847f04eabeb08.woff";